module.exports = __webpack_public_path__ + "media/images/sp/brands/eight/store_nagoya_ekimae-d49b97dde55c082edeb4dda7e9317913.jpg";